import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PLICBooksLogin from '../../components/global/PLICBooksLogin';

const propTypes = {
  className: PropTypes.string,
};

const PlicBooksOAuth = ({ className }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <PLICBooksLogin
        className="login-email-form-button email-signin-button"
        btnSize="sm"
        btnOutline
      >
        Sign in with PLIC Books!
      </PLICBooksLogin>
    </div>
  );
};

PlicBooksOAuth.propTypes = propTypes;

export default PlicBooksOAuth;
